import { Spinner } from '@fluentui/react-components';
import { makeStyles } from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
  },
});

export function PageLoader() {
  const styles = useStyles();
  return (
    <div className={styles.container}>
      <Spinner size="huge" label="Loading…" />
    </div>
  );
}
